import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { GetAgentWalletConfigurationHistory } from '../../../../Services';
import { NoDataFound } from '../../../../Components';
import CustomPaginationHistorySideMenu from '../../../../Components/V2/CustomHistoryComponent/Sections/HistoryComponent/UI/CustomPaginationHistorySideMenu/CustomPaginationHistorySideMenu';
import HistoryTimelineItem from './HistoryTimelineItem';
import { showError } from '../../../../Helper';

import useStyles from './styles';
export default function AgentWalletHistoryComponent({ activeItem }) {
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [historyData, setHistoryData] = useState({
    data: [],
    totalCount: 0,
  });
  const styles = useStyles();
  const getAgentWalletConfigurationHistory = async () => {
    setIsLoading(true);
    try {
      const res = await GetAgentWalletConfigurationHistory({
        pageIndex: filter.pageIndex + 1,
        pageSize: filter.pageSize,
      });
      setHistoryData({
        data: res.result,
        totalCount: res.totalCount,
      });
    } catch {
      showError('Error in sendConfigurationContent:');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAgentWalletConfigurationHistory();
  }, [filter, JSON.stringify(activeItem)]);
  return (
    <Box className={styles.AgentWalletHistoryComponentContainer}>
      <Box className={styles.AgentWalletHistoryComponentWraper}>
        {isLoading ? (
          <Box className={styles.loaderContainer}>
            <CircularProgress />
          </Box>
        ) : historyData?.data.length > 0 ? (
          <HistoryTimelineItem historyData={historyData.data} />
        ) : (
          <NoDataFound title={'History'} />
        )}
      </Box>
      <CustomPaginationHistorySideMenu
        totalItems={historyData.totalCount}
        itemsPerPage={filter.pageSize}
        currentPage={filter.pageIndex}
        onPageChange={(page) =>
          setFilter((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setFilter((prev) => ({ ...prev, pageSize: items }))
        }
      />
    </Box>
  );
}
